import React, {Component} from 'react';
import * as actions from "../../store/actions";
import connect from "react-redux/es/connect/connect";
import BasicMap from "../../components/WorldCountriesMap/BasicMap";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {HomeSidebarComponent} from "../../v2/components/sidebars/homeSidebarComponent";
import {MiniCardComponent} from "../../v2/minicard/minicard";

class Home extends Component {

    state = {
        countriesPerContinent: []
    };

    componentDidMount = async () => {
        await this.props.onDrugsCountFetch();
    };

    shareContinentsInfo = data => {
        const countriesPerContinent = Object.keys(data).map(key => [key, data[key]]);
        this.setState({countriesPerContinent});
    };

    render() {
        if (!this.props.drugsPerCountry) {
            return <div className={"d-flex align-items-center justify-content-center"}
                        style={{color: '#5c5a5d', minHeight: 80 + 'vh'}}><CircularProgress/></div>
        }
        return (
            <div className={"row"}>
                <div className="col-3 d-flex flex-wrap no-padding">
                    <div className="col-12 px-0">
                        <MiniCardComponent
                            value={this.props.drugsCount}
                            text={'Total Drugs'}
                        />
                    </div>
                    <div className="col-6 pl-0">
                        <MiniCardComponent
                            value={this.props.countriesCovered}
                            text={'Countries'}
                        />
                    </div>
                    <div className="col-6 pr-0">
                        <MiniCardComponent
                            value={this.state.countriesPerContinent.length}
                            text={'Continents'}
                        />
                    </div>
                    <HomeSidebarComponent
                        countriesPerContinent={this.state.countriesPerContinent}
                        drugsCount={this.props.drugsCount}
                        countriesCovered={this.props.countriesCovered}
                    />
                </div>
                <div className="col-9">
                    <BasicMap shareContinentsInfo={this.shareContinentsInfo}
                              drugsPerCountry={this.props.drugsPerCountry}/>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        drugsPerCountry: state.drugs.drugsPerCountry,
        drugsCount: state.drugs.drugsCount,
        countriesCovered: state.drugs.countriesCovered
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onDrugsCountFetch: () => dispatch(actions.getDrugsCountPerCountry()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
